import { render, staticRenderFns } from "./IdentityDocument.vue?vue&type=template&id=59d6ec92"
import script from "./IdentityDocument.vue?vue&type=script&lang=js"
export * from "./IdentityDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports